module.exports = __webpack_public_path__ + "static/img/xueyecover.3d2b7503.png";